import React, { useState, useEffect } from "react";
import styles from "./Dialog.module.css";

export const Advise: React.FC = () => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (countdown <= 0) {
      window.location.href = "https://www.microsip.com/precios";
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <>
      <div className={styles.backdrop}></div>
      <div className={styles.dialog}>
        <div className={styles.logoContainer}>
          <img
            src="https://cdn.prod.website-files.com/627983ccef617d453b9485ad/668c7a0b956392b1b8792159_Logo-Microsip-HD-p-500.png"
            alt="Microsip Logo"
            className={styles.logo}
          />
        </div>
        {/* <h2 className={styles.header}>Estimado Partner Microsip:</h2> */}
        <div className={styles.content}>
          <p>
            A partir del <strong>5 de mayo de 2025</strong>, este sitio fue
            desactivado. Puedes consultar los precios actualizados directamente
            en:
          </p>
          <a
            href="https://www.microsip.com/precios"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            www.microsip.com/precios
          </a>
          <p className={styles.thanks}>
            ¡Gracias por utilizar nuestra plataforma!
          </p>
        </div>
        <div className={styles.actions}>
          <div className={styles.countdownContainer}>
            <span className={styles.countdown}>
              Redirigiendo en {countdown} segundos
            </span>
          </div>
          <button
            className={styles.pricesButton}
            onClick={() =>
              window.open("https://www.microsip.com/precios", "_blank")
            }
          >
            IR A PRECIOS
          </button>
        </div>
      </div>
    </>
  );
};
